var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(_vm.labelCols)?_c('LabelCol',{attrs:{"cols":_vm.labelCols,"attribute":_vm.attribute}}):_vm._e(),_c('v-col',{staticClass:"pa-0",attrs:{"cols":_vm.valueCols}},[_c('v-text-field',{attrs:{"value":_vm.computedValue,"readonly":"","outlined":"","label":_vm.attribute.measure_unit?_vm.unitLabel(_vm.attribute.measure_unit):null}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }